import { Injectable, signal } from '@angular/core';

export interface UserData {
    id: string;
    name: string;
    email?: string;
    username?: string;
    emailVerified?: boolean;
    roles?: string[];
    isAdmin?: boolean;
    isAuditor?: boolean;
}

@Injectable({ providedIn: 'root' })
export class UserStoreService {
    private _user = signal<UserData | null>(null);

    readonly user = this._user.asReadonly();

    setUser(user: UserData) {
        this._user.set(user);
    }

    clearUser() {
        this._user.set(null);
    }
}
